import { SITE_URL } from '@/lib/seo';

export const INVITE_CODE_QUERY_KEY = 'inviteCode';

export function normalizeInviteCode(inviteCode?: string | null): string | null {
  const normalizedCode = inviteCode?.trim();
  return normalizedCode ? normalizedCode : null;
}

export function getInviteCodeFromSearch(search?: string): string | null {
  const rawSearch = search ?? (typeof window !== 'undefined' ? window.location.search : '');
  if (!rawSearch) {
    return null;
  }

  try {
    const params = new URLSearchParams(rawSearch.startsWith('?') ? rawSearch : `?${rawSearch}`);
    return normalizeInviteCode(params.get(INVITE_CODE_QUERY_KEY));
  } catch {
    return null;
  }
}

export function getInviteCodeFromWindowLocation(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }

  return getInviteCodeFromSearch(window.location.search);
}

export function appendInviteCodeToPath(path: string, inviteCode?: string | null): string {
  const normalizedCode = normalizeInviteCode(inviteCode);
  if (!normalizedCode) {
    return path;
  }

  try {
    const url = new URL(path, SITE_URL);
    url.searchParams.set(INVITE_CODE_QUERY_KEY, normalizedCode);
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return path;
  }
}

export function buildInviteLandingUrl(inviteCode: string, origin?: string): string {
  const normalizedCode = normalizeInviteCode(inviteCode);
  const baseOrigin = origin ?? (typeof window !== 'undefined' ? window.location.origin : SITE_URL);
  const url = new URL('/', baseOrigin);

  if (normalizedCode) {
    url.searchParams.set(INVITE_CODE_QUERY_KEY, normalizedCode);
  }

  return url.toString();
}
